import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook to monitor session timeout and redirect to login after 8 hours of inactivity
 */
export const useSessionTimeout = () => {
  const navigate = useNavigate();

  const checkSessionExpiry = useCallback(() => {
    const sessionExpiresAt = sessionStorage.getItem('sessionExpiresAt');
    const anonymousExpiresAt = sessionStorage.getItem('anonymousExpiresAt');

    const expiresAt = sessionExpiresAt || anonymousExpiresAt;
    if (!expiresAt) {
      // No session to check
      return;
    }

    const expiryTime = new Date(expiresAt).getTime();
    const now = Date.now();

    if (now >= expiryTime) {
      console.warn('Session expired due to inactivity - redirecting to login');
      sessionStorage.clear();
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    // Check immediately
    checkSessionExpiry();

    // Check every minute
    const intervalId = setInterval(() => {
      checkSessionExpiry();
    }, 60 * 1000); // 1 minute

    return () => {
      clearInterval(intervalId);
    };
  }, [checkSessionExpiry]);
};
